/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_TitleInputs */

const en_admin_indexnow_title = /** @type {(inputs: Admin_Indexnow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IndexNow`)
};

/**
* | output |
* | --- |
* | "IndexNow" |
*
* @param {Admin_Indexnow_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_title = /** @type {((inputs?: Admin_Indexnow_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_title(inputs)
});
export { admin_indexnow_title as "admin.indexnow.title" }